/**
 * Where a typed message goes while a live call may be up. 'voice' means
 * "offer it to the bot first" — the caller still falls back to the text
 * turn when no call is actually live. Hidden seeds (experience goals,
 * continuation ticks) and the mock runtime always take the text path.
 */
export function routeTypedMessage(opts: { hidden?: boolean; mock?: boolean }): 'voice' | 'chat' {
  if (opts.hidden || opts.mock) return 'chat';
  return 'voice';
}
